const AUTH_ERROR_MAP = {
  'auth/invalid-credential': 'Email ou senha incorretos.',
  'auth/user-not-found': 'Usuário não encontrado.',
  'auth/wrong-password': 'Senha incorreta.',
  'auth/invalid-email': 'Email inválido.',
  'auth/too-many-requests': 'Muitas tentativas. Tente novamente mais tarde.',
  'auth/network-request-failed': 'Erro de conexão. Verifique sua internet.',
  'auth/user-disabled': 'Esta conta foi desativada.',
  'auth/email-already-in-use': 'Este email já está cadastrado. Tente fazer login.',
  'auth/weak-password': 'Senha muito fraca. Use pelo menos 8 caracteres, com número e letra maiúscula.',
  'auth/invalid-continue-uri': 'URL de retorno inválida. Tente novamente em instantes.',
  'auth/unauthorized-continue-uri': 'Domínio não autorizado no Firebase. Contate o suporte.',
};

export const translateAuthError = (error, fallback = 'Ocorreu um erro. Tente novamente.') => {
  const code = error?.code || '';
  return AUTH_ERROR_MAP[code] || fallback;
};
